module.exports = __webpack_public_path__ + "img/Launcher.581b1f06.png";